module.exports = __webpack_public_path__ + "static/media/erik-lindgren-23216-unsplash.1060de9e.jpg";